import AddressLocodeAndCustomFields from "components/organisms/AddressLocodeAndCustomFields/AddressLocodeAndCustomFields";
import { useFormContext } from "react-hook-form";

interface AddressV2DisplayProps {
  addressNameKey: string;
  addressStreetKey: string;
  addressStreetLine2Key: string;
  addressCityKey: string;
  addressStateKey: string;
  addressCountryKey: string;
  addressZipcodeKey: string;
  unLocodeKey: string;
  locationReferenceNumberKey: string;
  customAddressReferenceKey: string;
}

export default function AddressV2Display({
  addressNameKey,
  addressStreetKey,
  addressStreetLine2Key,
  addressCityKey,
  addressStateKey,
  addressCountryKey,
  addressZipcodeKey,
  unLocodeKey,
  locationReferenceNumberKey,
  customAddressReferenceKey,
}: AddressV2DisplayProps) {
  const { getValues } = useFormContext();

  return (
    <div className="font-b3">
      <div className="font-weight-bold">{getValues(addressNameKey)}</div>
      <div>{getValues(addressStreetKey)}</div>
      <div>{getValues(addressStreetLine2Key)}</div>
      <div>
        {getValues(addressCityKey)}
        {getValues(addressStateKey) && `, ${getValues(addressStateKey)}`}
        {getValues(addressCountryKey) && `, ${getValues(addressCountryKey)}`} {getValues(addressZipcodeKey)}
      </div>
      <AddressLocodeAndCustomFields
        un_locode={getValues(unLocodeKey)}
        location_reference_number={getValues(locationReferenceNumberKey)}
        custom_address_reference={getValues(customAddressReferenceKey)}
        un_locode_className="font-b4"
      />
    </div>
  );
}
